import Box from "@mui/material/Box";
import {
    Alert,
    Checkbox, Chip,
    createTheme,
    FormControl,
    FormHelperText,
    Grid, Input,
    InputAdornment,
    InputLabel,
    Modal,
    OutlinedInput,
    Select,
    TextField, Tooltip
} from "@mui/material";
import { useEffect, useState } from "react";
import 'react-day-picker/dist/style.css';
import MenuItem from "@mui/material/MenuItem";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import { ApproveOrReject, UserRole, wordsLimit } from "../../../utils/consts";
import { ThemeProvider } from "@emotion/react";
import { commonStyles } from "../../../styles/commontStyles";
import Button from "@mui/material/Button";
import useCreateTraining from "../../../hooks/trainingHooks/useCreateTraining";
import useFetchTrainingTypes from "../../../hooks/trainingHooks/useFetchTrainingTypes";
import useFetchTrainingNames from "../../../hooks/trainingHooks/useFetchTrainingNames";
import { useSelector } from "react-redux";
import useUpdateTraining from "../../../hooks/trainingHooks/useUpdateTraining";
import useUpdateTrainingStatus from "../../../hooks/trainingHooks/useUpdateTrainingStatus";
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import { AddCircleOutlineOutlined } from "@mui/icons-material";
import { Controller, useForm } from "react-hook-form"
import { yupResolver } from "@hookform/resolvers/yup";
import { approveTrainingSchema, getTrainingSchema, traineeSchema } from "../../../utils/schema";
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc'
import { DemoContainer, DemoItem } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import useCommonQuery from "../../../hooks/trainingHooks/useCommonQuery";
import useConfirm from "../../../hooks/trainingHooks/useConfirm";
import moment from "moment";
import "../../../utils/timezone";
import { random } from "lodash";
import * as React from "react";

const styles = {
    modalStyle: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 500,
        bgcolor: 'background.paper',
        border: '2px solid #000',
        boxShadow: 24,
        p: 4,
    }
}

const theme = createTheme({
    typography: {
        span: {
            fontSize: '14px'
        },
        caption: {
            fontSize: '12px'
        }
    }
})

const TrainingApproveModal = ({ open, setOpen, isCreating, isUpdating, training }) => {

    const [trainingName, setTrainingName] = useState(isUpdating ? training.trainingName : '')
    const [trainingType, setTrainingType] = useState(isUpdating ? training.trainingType : '')
    const [stdtrainingName, setStdTrainingName] = useState(isUpdating ? training.stdtrainingName : '')
    const [stdtrainingType, setStdTrainingType] = useState(isUpdating ? training.stdtrainingType : '')


    const [filterFiscalYear, setfilterFiscalYear] = useState(true)
    const [note, setNote] = useState(isUpdating ? training.note : '')
    const [trainingsSelected, setTrainingsSelected] = useState([])
    const [displayErrorMessage, setDisplayErrorMessage] = useState(false)
    const { userName, userEmail, userRole } = useSelector(state => state.user)
    // const {isLoading, data: trainingTypes}
    //  = useFetchTrainingTypes(['queryAllTrainingTypes'], '/training/trainingTypes')
    const { isLoading, data: trainingNames } = useFetchTrainingNames(
        ['queryAllTrainingNames', '', 'DESC', 'Fiscal Yr', 1, 5, true],
        1, 5, '', 'DESC', 'Fiscal Yr', true
    )

    const { mutate: updateTraining } = useUpdateTraining()
    const { mutate: updateTrainingStatus } =
        useUpdateTrainingStatus(setTrainingsSelected)

    const { data: trainingTimePeriod } = useCommonQuery(
        ['queryFiscalYear'], '/training/currentFiscalYear')

    const [Dialog, confirmApprove] = useConfirm(
        'Are you sure?',
        'Are you sure you want to approve training?',
    )

    const {
        handleSubmit,
        control,
        reset,
        setValue,
        formState: { errors }
    } = useForm({
        resolver: yupResolver(approveTrainingSchema()),
    })

    useEffect(() => {
        if (isUpdating) {
            setValue('trainingType', training.trainingType)
            setValue('trainingName', training.trainingName)
            setValue('stdtrainingType', training.stdtrainingType)
            setValue('stdtrainingName', training.stdtrainingName)
            setValue('note', training.note)
        }
    }, [isUpdating])

    dayjs.extend(utc)
    const closeForm = () => {
        reset({
            trainingName: '',
            trainingType: '',
            stdtrainingType: '',
            stdtrainingName: '',
            note: '',
        })
        setDisplayErrorMessage(false)
        setOpen(false)
    }
    const rejectTrainingHandler = (data) => {
        const {
            trainingType,
            trainingName,
            note
        } = data

        const rejectedTraining = {
            trainingId: training.id,
            trainingName,
            trainingType,
            note,
        }
        rejectTrainingHandler(rejectedTraining)
        closeForm()
    }
    const updateTrainingHandler = (data) => {
        const {
            stdtrainingName
        } = data
        const ans = window.confirm("Are you sure you want to approve the training?")
        if (ans) {
            const updatedTraining = {
                trainingIds: training.id,
                approveOrReject: ApproveOrReject.APPROVE,
                stdtrainingName,
                note: '',
            }
            updateTrainingStatus(updatedTraining)
            closeForm()
        } else {
            closeForm()
        }
    }


    const rejectTrainings = (
        {
            numSelected,
            trainingsSelected,
            setTrainingsSelected,
        }
    ) => {

        updateTrainingStatus({
            trainingIds: trainingsSelected,
            approveOrReject: ApproveOrReject.REJECT
        });
    };

    return (
        <ThemeProvider theme={theme}>
            <Modal
                open={open}
                onClose={() => { closeForm() }}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >

                <Box sx={styles.modalStyle}>
                    <Grid item>
                        <Controller
                            control={control}
                            name='trainingType'
                            render={({ field }) => (
                                <FormControl
                                    sx={commonStyles.fullWidth}
                                    variant="outlined"
                                    error={!!errors.trainingType}
                                >
                                    <InputLabel htmlFor="outlined-adornment-password">Training Type</InputLabel>
                                    <OutlinedInput
                                        {...field}
                                        id="outlined-adornment-password"
                                        type='text'
                                        label="trainingType"
                                        disabled={isUpdating}
                                    />
                                    {
                                        errors.trainingType && <FormHelperText id="my-helper-text">{errors.trainingType.message}</FormHelperText>
                                    }
                                </FormControl>
                            )}
                        />
                    </Grid>

                    <Grid item>
                        <Controller
                            control={control}
                            name='trainingName'
                            render={({ field }) => (
                                <FormControl
                                    sx={commonStyles.fullWidth}
                                    variant="outlined"
                                    error={!!errors.trainingName}
                                >
                                    <InputLabel htmlFor="outlined-adornment-password">Training Name</InputLabel>
                                    <OutlinedInput
                                        {...field}
                                        id="outlined-adornment-password"
                                        type='text'
                                        label="trainingName"
                                        disabled={isUpdating}
                                    />
                                    {
                                        errors.trainingName && <FormHelperText id="my-helper-text">{errors.trainingName.message}</FormHelperText>
                                    }
                                </FormControl>
                            )}
                        />
                    </Grid>

                    <Grid item>
                        <Controller
                            control={control}
                            name='stdtrainingName'
                            render={({ field }) => (
                                <FormControl
                                    sx={commonStyles.fullWidth}
                                    error={!!errors.stdtrainingType && !!errors.stdtrainingName}
                                >
                                    <InputLabel id="demo-simple-select-label">Standard Training Name</InputLabel>
                                    <Select
                                        {...field}
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        label="stdtrainingName"
                                    >
                                        {
                                            !isLoading && trainingNames.map((trainingNamesList, index) => (<MenuItem key={index} value={trainingNamesList.trainingName}>FY{trainingNamesList.fiscal_yr} - {trainingNamesList.trainingName}</MenuItem>))
                                        }
                                    </Select>

                                    {
                                        errors.trainingName && <FormHelperText id="my-helper-text">{errors.trainingName.message}</FormHelperText>
                                    }
                                </FormControl>
                            )}
                        />
                    </Grid>

                    <Grid item>
                        <Grid
                            container
                            alignItems='center'
                            justifyContent='center'
                            spacing={1}
                        >
                            <Grid item>
                                <Button
                                    variant="contained"
                                    disableElevation
                                    size="small"
                                    onClick={handleSubmit(updateTrainingHandler)}
                                >
                                    Approve
                                </Button>
                            </Grid>


                            <Grid item>
                                <Button
                                    variant="outlined"
                                    onClick={() => closeForm()}
                                >
                                    Cancel
                                </Button>
                            </Grid>
                        </Grid>
                    </Grid>
                </Box>
            </Modal>
        </ThemeProvider>
    )
}

export default TrainingApproveModal
